/**
 * Generate participant key for V2 permalink.
 * The key is user IDs sorted alphabetically and joined with underscore.
 */
export const generateParticipantKey = (userIds: string[]): string => {
	return [...userIds].sort().join('_');
};
